<template>
  <b-modal
    v-model="showModal"
    id="tipPaymentModal"
    modal-class="tip-payment-modal"
    title="Enter Gratuity"
    centered
    hide-footer
    size="md"
  >
    <b-row v-if="tipTab.stats" class="pt-4">
      <b-col class="tip-guest-tab pr-0" cols="8">
        <guest-tab
          ref="tipGuestTab"
          component-id="tip-guest-tab"
          :tab="tipTab"
          :extra-tip="tip_amount"
          :hide-header="true"
          :show-description="false"
        />
      </b-col>

      <b-col class="tip-amount-buttons">
        <b-btn
          class="tip-amount-button"
          variant="secondary"
          @click="setTipAmount(tip_rate_1)"
        >
          {{ tip_rate_1 }} %
        </b-btn>

        <b-btn
          class="tip-amount-button mt-3"
          variant="secondary"
          @click="setTipAmount(tip_rate_2)"
        >
          {{ tip_rate_2 }} %
        </b-btn>

        <b-btn
          class="tip-amount-button mt-3"
          variant="secondary"
          @click="setTipAmount(tip_rate_3)"
        >
          {{ tip_rate_3 }} %
        </b-btn>

        <b-btn
          class="tip-amount-button mt-3"
          variant="secondary"
          @click="showTipRateModal()"
        >
          Other
        </b-btn>

        <b-btn
          class="tip-amount-button mt-3"
          variant="success"
          @click="approveTipAmount()"
        >
          Approve
        </b-btn>
      </b-col>
    </b-row>

    <b-modal
      v-model="showInputRateModal"
      title="Enter Tip Rate"
      centered
      size="sm"
    >
      <b-form>
        <info-row class="info-main-row" title="Tip Rate">
          <currency-input
            name="Tip Rate"
            currency-symbol="%"
            :size="12"
            :amount.sync="tip_rate"
            :fieldState="fieldState.tip_rate"
          />
        </info-row>
      </b-form>

      <div slot="modal-footer" class="w-100">
        <b-btn
          class="float-right"
          variant="success"
          @click="setTipRate()"
        >
          Set Tip Rate
        </b-btn>
      </div>
    </b-modal>
  </b-modal>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { PAYMENT_TYPES, PAYMENT_METHODS } from '@/config/constants'
import { formatMoney } from '@/utils/number-utils';
import cloneDeep from "lodash.clonedeep";

export default {
  name: 'CollectPaymentModal',

  props: {
    payer: {
      type: String,
      default: 'Hotel'
    },

    tab: {
      type: Object,
      default: () => {}
    }
  },

  components: {
    GuestTab: () => import('@/components/GuestTab'),
    CurrencyInput: () => import('@/components/widgets/CurrencyInput'),
    InfoRow: () => import('@/components/InfoRow')
  },

  data() {
    return {
      tip_amount: 0,
      tip_rate: 0,
      tipTab: {},
      showModal: false,
      showInputRateModal: false,
      checkingForm: false,
      paymentMethods: PAYMENT_METHODS
    }
  },

  computed: {
    ...mapGetters([
      'getVendor'
    ]),

    fieldState () {
      return {
        tip_rate: !this.checkingForm
          ? null
          : !!this.tip_rate
      };
    },

    tip_rate_1 () {
      return this.getVendor && this.getVendor.tip_rate_1
        ? parseFloat(this.getVendor.tip_rate_1)
        : 0;
    },

    tip_rate_2 () {
      return this.getVendor && this.getVendor.tip_rate_2
        ? parseFloat(this.getVendor.tip_rate_2)
        : 0;
    },

    tip_rate_3 () {
      return this.getVendor && this.getVendor.tip_rate_3
        ? parseFloat(this.getVendor.tip_rate_3)
        : 0;
    }
  },

  mounted () {
    this.tipTab = cloneDeep(this.tab);
  },

  methods: {
    show () {
      this.tip_amount = 0;
      this.showModal = true;
    },

    hide () {
      this.showModal = false;
    },

    setTipAmount (value) {
      this.tip_amount = parseFloat((this.tab.stats.sub_total * value / 100).toFixed(2));
    },

    setTipRate () {
      this.checkingForm = true;

      if (!this.fieldState.tip_rate) {
        return;
      }

      this.setTipAmount(this.tip_rate);
      this.showInputRateModal = false;
    },

    showTipRateModal () {
      this.tip_rate = 0;
      this.checkingForm = false;
      this.showInputRateModal = true;
    },

    approveTipAmount () {
      this.$emit('submit', this.tip_amount);
      this.hide();
    }
  },

  watch: {
    tab () {
      this.tipTab = cloneDeep(this.tab);
    }
  }
};
</script>

<style lang="scss">
.tip-payment-modal {
  .modal-dialog {
    max-width: 650px;
  }

  .modal-body {
    padding: 0px 30px 30px 30px;
  }

  .tip-guest-tab {
    .guest-tab {
      margin: 0;
      padding: 0;

      .guest-tab-window {
        max-height: 100%;
      }
    }
  }

  .tip-amount-buttons {
    & > div {
      text-align: center;
    }

    .btn {
      width: 80%;
    }
  }
}
</style>
